import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_LOCAL_API_URL;

function ForgotPassword() {
  const [identifier, setIdentifier] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  async function submit(event) {
    event.preventDefault();
    try {
      const response = await axios.post(`${API_URL}/auth/forgot-password`, { identifier });
      setMessage(response.data.message);
      setError("");
    } catch {
      setError("Begäran kunde inte behandlas just nu");
    }
  }

  return <div className="mx-auto w-full max-w-xl px-4 py-6">
    <div className="theme-card">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-sky-700">Säkerhet</p>
      <h1 className="mt-2 text-lg font-bold text-slate-800">Glömt lösenord</h1>
      <p className="mt-2 text-sm text-slate-600">Ange användarnamn eller verifierad e-postadress.</p>
      <form onSubmit={submit} className="mt-4 grid gap-3">
        <input className="theme-input" value={identifier} onChange={(event) => setIdentifier(event.target.value)} required />
        <button className="theme-button-primary" type="submit">Skicka återställningslänk</button>
      </form>
      {message && <div className="theme-alert-success mt-4">{message}</div>}
      {error && <div className="theme-alert-error mt-4">{error}</div>}
      <Link className="mt-4 inline-block text-sm font-semibold text-sky-700" to="/login">Till inloggningen</Link>
    </div>
  </div>;
}

export default ForgotPassword;
